/**
 * @element qds-settings-button
 * 
 * A button component for accessing settings.
 * 
 * @csspart button - The button container
 * @csspart icon - The settings icon
 * 
 * @fires click - When the settings button is clicked
 */

import { createBaseButtonComponent } from '../shared/button-utils.js';

// Create the settings button component with the cog icon
const QdsSettingsButton = createBaseButtonComponent('pi-cog');

// Only define the custom element if it's not already defined
if (!customElements.get('qds-settings-button')) {
  customElements.define('qds-settings-button', QdsSettingsButton);
}

// Export the component class for TypeScript type checking and documentation
export { QdsSettingsButton };